/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material';
import { Iceutility } from '../../services/iceutility';

@Component({
  selector: 'icepagination',
  templateUrl: './icepagination.component.html',
  styleUrls: ['./icepagination.component.scss']
})
export class IcePaginationComponent implements OnInit {
  @Input() data: any = [];
  @Input() pageSize: number;
  @Input() pageSizeOptions: number[];
  @Input() showFirstLastButtons: boolean;
  @Input() hidden: boolean;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    if (this.data)
      this.data.paginator = this.paginator;

    if (!Iceutility.isdefined(this.pageSize)) {
      this.pageSize = 20;
    }
    if (!Iceutility.isdefined(this.pageSizeOptions)) {
      this.pageSizeOptions = [5, 10, 20];
    }
    if (!Iceutility.isdefined(this.showFirstLastButtons)) {
      this.showFirstLastButtons = true;
    }
    if (!Iceutility.isdefined(this.hidden)) {
      this.hidden = false;
    }
  }
}
